import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { Utils } from '@logio/common-be-fe';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/compiled-icons.css';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import debounce from 'lodash/debounce';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Key } from '../../../shared/keyboard/Key';
import { StoreName } from '../../../shared/stores/StoreName';
import withValidation from '../../inputs/withValidation';
import AgGridStore from './AgGridStore';
import CustomHeader from './components/CustomHeader';
import { default as Editors } from './components/editors';
import ExportToExcel from './components/ExportToExcel';
import Filters from './components/filters';
import GridSettingsBar from './components/GridSettingsBar';
import Maximize from './components/Maximize';
import Renderers, { RendererNames } from './components/renderers';
import ResetAll from './components/ResetAll';
import StyledAgGrid from './styled/AgGrid';
import Tooltips from './components/tooltips';
import ReactResizeDetector from 'react-resize-detector';
import { MinimalisticPagination } from '../../navigation/Pagination';
import { Row } from 'react-flexbox-grid';
import CustomExportToExcel from './components/CustomExportToExcel';
import { ExcelStyles } from './components/ExcelStyles';
import logger from '../../../shared/logger';
import { merge } from 'lodash';
import DefaultLoadingOverlay from './components/overlays/DefaultLoadingOverlay';
import { OverlayNames } from './components/overlays';
import GridViewApi from './GridViewApi';
import Formatters from './components/formatters';

var AgGrid =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AgGrid, _React$Component);

  function AgGrid(props) {
    var _this;

    _classCallCheck(this, AgGrid);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AgGrid).call(this, props));
    _this.store = new AgGridStore(_this.props.gridId);
    _this.isGridInitialized = false;
    /**
     *  Saves tree expansion
     */

    _this.saveRowExpansion = function () {
      var expandedRowNodes = [];

      if (_this.gridApi) {
        _this.gridApi.forEachNode(function (node) {
          if (node.expanded) {
            expandedRowNodes.push("".concat(node.id, "-").concat(node.key));
          }
        });
      }

      _this.props.grid.rowExpansions.set(_this.props.saveTreeDataExpansionId, expandedRowNodes);
    };
    /**
     *  Restores tree expansion
     */


    _this.restoreRowExpansion = function () {
      var expandedRowNodes = _this.props.grid.rowExpansions.get(_this.props.saveTreeDataExpansionId);

      if (expandedRowNodes) {
        _this.gridApi.forEachNode(function (node) {
          if (expandedRowNodes.includes("".concat(node.id, "-").concat(node.key))) {
            node.expanded = true;
          }
        });

        _this.gridApi.onGroupExpandedOrCollapsed();
      }
    };
    /**
     * Calculates the height of the grid to the height of the screens remaining space.
     */


    _this.setAutoHeight = function () {
      if (_this.calculateAutoHeight) {
        var grid = _this.ref.current;
        var padding = grid.closest('.box-tab-container') || _this.isInModal ? 65 : 33; // 65 = ugly form of 2x 2rem + 1px

        if (grid) {
          var gridOffset = grid.getBoundingClientRect();
          var calculatedHeight = _this.state.maximized ? window.innerHeight : window.innerHeight - gridOffset.top - padding;

          _this.setState({
            autoHeight: _this.props.heightFunc ? _this.props.heightFunc(_this.ref) : calculatedHeight
          });
        }
      }
    };
    /**
     * Calculates the height of the grid to the height of the screens.
     * @returns number
     */


    _this.viewportCalculation = function () {
      var grid = _this.ref.current;

      if (grid) {
        var padding = grid.closest('.box-tab-container') ? 100 : 60;
        return window.innerHeight - padding;
      }

      return null;
    };

    _this.setAutoHeightDebounced = debounce(_this.setAutoHeight, 500);

    _this.escMaximize = function (e) {
      if (e.key === Key.Escape) {
        e.stopPropagation();

        _this.toggleMaximize();
      }
    };

    _this.toggleMaximize = function () {
      // Switch domLayout to normal in the maximized grid for being all over the page
      if (_this.props.domLayout) {
        _this.gridApi.setDomLayout(_this.state.maximized ? _this.props.domLayout : 'normal');
      }

      _this.setState({
        maximized: !_this.state.maximized
      }, function () {
        if (_this.state.maximized) {
          _this.ref.current.addEventListener('keyup', _this.escMaximize);
        } else {
          _this.ref.current.removeEventListener('keyup', _this.escMaximize);
        }
      });
    };

    _this.statusPanels = function (props) {
      var panels = [];
      var currentFilterModel = _this.gridApi ? _this.gridApi.getFilterModel() : undefined; // Quick view panel

      if (props.quickView) {
        panels.push({
          statusPanel: 'GridSettingsBar',
          statusPanelParams: {
            store: _this.store
          },
          align: 'left'
        });
      } // AgGrid row count summary


      if (props.rowCountStatus !== false) {
        panels.push({
          statusPanel: 'agFilteredRowCountComponent',
          align: 'right'
        }, {
          statusPanel: 'agTotalRowCountComponent',
          align: 'right'
        });
      } // AgGrid settings reset button


      panels.push({
        statusPanel: 'ResetAll'
      }); // AgGrid excel export button

      if (props.excelExportParams && props.excelExportParams.getRowDataToExport && props.excelExportParams.type && props.excelExportParams.type === 'custom') {
        panels.push({
          statusPanel: 'CustomExportToExcel',
          statusPanelParams: {
            excelExportParams: props.excelExportParams,
            mainGridOptions: Object.assign({}, props),
            getRowData: function getRowData() {
              return props.excelExportParams.getRowDataToExport(currentFilterModel);
            },
            getColumnDefs: props.excelExportParams.getColumnDefs
          }
        });
      } else {
        panels.push({
          statusPanel: 'ExportToExcel',
          statusPanelParams: {
            excelExportParams: props.excelExportParams
          }
        });
      } // AgGrid maximize button


      panels.push({
        statusPanel: 'Maximize',
        statusPanelParams: {
          toggleMaximize: _this.toggleMaximize,
          maximized: _this.state.maximized
        }
      });
      return panels.filter(function (x) {
        return x;
      });
    };

    _this.render = function () {
      var _a = _this.props,
          onGridReady = _a.onGridReady,
          frameworkComponents = _a.frameworkComponents,
          defaultColDef = _a.defaultColDef,
          internalPagination = _a.internalPagination,
          columnDefs = _a.columnDefs,
          sortColumnsAlphabetically = _a.sortColumnsAlphabetically,
          _a$animateRows = _a.animateRows,
          animateRows = _a$animateRows === void 0 ? false : _a$animateRows,
          _a$suppressColumnMove = _a.suppressColumnMoveAnimation,
          suppressColumnMoveAnimation = _a$suppressColumnMove === void 0 ? true : _a$suppressColumnMove,
          _a$suppressAnimationF = _a.suppressAnimationFrame,
          suppressAnimationFrame = _a$suppressAnimationF === void 0 ? false : _a$suppressAnimationF,
          _a$rowBuffer = _a.rowBuffer,
          rowBuffer = _a$rowBuffer === void 0 ? 20 : _a$rowBuffer,
          rest = __rest(_a, ["onGridReady", "frameworkComponents", "defaultColDef", "internalPagination", "columnDefs", "sortColumnsAlphabetically", "animateRows", "suppressColumnMoveAnimation", "suppressAnimationFrame", "rowBuffer"]);

      var sortedColumnDefs = sortColumnsAlphabetically ? _this.sortColumns(columnDefs) : columnDefs;
      sortedColumnDefs = _this.enforceSimpleFilterForOverviewMode(sortedColumnDefs);
      var detailCellRendererParams;

      if (rest.detailCellRendererParams) {
        var modifiedDetailCellRendererParams = _toConsumableArray(rest.detailCellRendererParams.detailGridOptions.columnDefs).map(function (item) {
          delete item.schema;
          return Object.assign({}, item);
        });

        detailCellRendererParams = Object.assign({}, merge({}, rest.detailCellRendererParams || {}, {
          detailGridOptions: {
            columnDefs: modifiedDetailCellRendererParams,
            frameworkComponents: Object.assign(Object.assign({}, _this.state.frameworkComponents), frameworkComponents)
          }
        }));
      }

      return React.createElement("div", {
        className: "ag-theme-balham ".concat(_this.store.invalid),
        ref: _this.ref
      }, (!_this.calculateAutoHeight || _this.state.autoHeight != null || _this.state.maximized) && React.createElement(StyledAgGrid, Object.assign({
        style: {
          height: _this.height
        },
        maximized: _this.state.maximized,
        isInModal: _this.isInModal,
        columnDefs: sortedColumnDefs
      }, rest), React.createElement(AgGridReact, Object.assign({
        accentedSort: true,
        aggFuncs: {
          group: _this.groupAggregation
        },
        animateRows: animateRows,
        suppressColumnMoveAnimation: suppressColumnMoveAnimation,
        suppressAnimationFrame: suppressAnimationFrame,
        rowBuffer: rowBuffer,
        columnDefs: sortedColumnDefs,
        defaultColDef: Object.assign(Object.assign({}, _this.state.defaultColumnDef), defaultColDef),
        defaultExportParams: _this.state.defaultExportParams,
        enableRangeSelection: true,
        frameworkComponents: Object.assign(Object.assign({}, _this.state.frameworkComponents), frameworkComponents),
        loadingOverlayComponent: !_this.props.loadingOverlayComponentFramework ? OverlayNames.DefaultLoadingOverlay : undefined,
        getContextMenuItems: _this.getContextMenuItems,
        groupDefaultExpanded: 1,
        headerHeight: 50,
        onGridReady: _this.onGridReady,
        onRowSelected: _this.handleRowSelection,
        pinnedTopRowData: _this.getPinnedTopRowData(),
        sideBar: {
          toolPanels: [{
            id: 'columns',
            labelDefault: 'Columns',
            labelKey: 'columns',
            iconKey: 'columns',
            toolPanel: 'agColumnsToolPanel',
            toolPanelParams: {
              suppressRowGroups: true,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
              suppressSideButtons: true,
              suppressColumnExpandAll: true
            }
          }]
        },
        statusBar: {
          statusPanels: _this.statusPanels(_this.props)
        },
        suppressPropertyNamesCheck: true,
        suppressScrollOnNewData: true,
        suppressClipboardPaste: true,
        context: {
          store: _this.store
        },
        stopEditingWhenGridLosesFocus: true,
        suppressRowClickSelection: true,
        processCellForClipboard: function processCellForClipboard(params) {
          var colDef = params.column.getColDef();
          var formatter = colDef.valueFormatter || colDef.excel && colDef.excel.valueFormatter;

          if (typeof formatter === 'function') {
            var valueFormatterParams = {
              node: params.node,
              data: params.value,
              colDef: params.column.getColDef(),
              column: params.column,
              api: params.api,
              columnApi: params.columnApi,
              context: params.context,
              value: params.value
            };
            return formatter(valueFormatterParams);
          } else {
            return params.value;
          }
        },
        enableBrowserTooltips: false,
        excelStyles: ExcelStyles
      }, rest, {
        detailCellRendererParams: detailCellRendererParams ? detailCellRendererParams : undefined,
        pagination: internalPagination ? rest.pagination : undefined,
        paginationPageSize: internalPagination ? rest.paginationPageSize : undefined,
        paginationAutoPageSize: internalPagination ? rest.paginationAutoPageSize : undefined,
        suppressPaginationPanel: internalPagination ? rest.suppressPaginationPanel : undefined
      }))), React.createElement(ReactResizeDetector, {
        handleWidth: true,
        handleHeight: true,
        onResize: _this.setAutoHeight,
        refreshMode: "throttle",
        skipOnMount: true,
        querySelector: "#main-content"
      }), rest.pagination && !internalPagination && React.createElement(Row, {
        style: {
          justifyContent: 'flex-end',
          padding: '5px 0'
        }
      }, React.createElement(MinimalisticPagination, {
        totalPages: rest.paginationTotalPages,
        activePage: rest.paginationActivePage,
        handlePageChange: rest.paginationHandlePageChange,
        showAdditionalInfo: !Utils.isValueMissing(rest.paginationLimit) && !Utils.isValueMissing(rest.paginationOffset) && !Utils.isValueMissing(rest.paginationTotal),
        limit: rest.paginationLimit,
        offset: rest.paginationOffset,
        totalItems: rest.paginationTotal
      })));
    }; // TODO: LOG-5989 - remove this


    if (props.onStoreReady) {
      props.onStoreReady(_this.store);
    } // Set licence key for AgGrid pro


    LicenseManager.setLicenseKey('Etnetera_a.s._LogioPP_2Devs4_October_2019__MTU3MDE0MzYwMDAwMA==b12f8fd71ab3a0ec2295d5339a99f666');

    _this.store.setPinnedTopRows(!!_this.props.showAggRow, !!_this.props.showBulkRow);

    _this.onGridReady = _this.onGridReady.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getContextMenuItems = _this.getContextMenuItems.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.validateInputValue = _this.validateInputValue.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.preventCellClick = _this.preventCellClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getBulkRow = _this.getBulkRow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getAggRow = _this.getAggRow.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleRowSelection = _this.handleRowSelection.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.b64toBlob = _this.b64toBlob.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.getPinnedTopRowData = _this.getPinnedTopRowData.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.state = {
      // Default column definitions
      defaultColumnDef: {
        headerComponent: 'CustomHeader',
        menuTabs: ['filterMenuTab', 'generalMenuTab'],
        sortable: true,
        filter: true,
        resizable: true
      },
      searchText: '',
      defaultExportParams: {
        suppressTextAsCDATA: true
      },
      // Register framework components
      frameworkComponents: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        CustomHeader: CustomHeader,
        ExportToExcel: ExportToExcel,
        CustomExportToExcel: CustomExportToExcel,
        GridSettingsBar: GridSettingsBar,
        ResetAll: ResetAll,
        Maximize: Maximize
      }, Filters), Editors), Renderers), Tooltips), _defineProperty({}, OverlayNames.DefaultLoadingOverlay, DefaultLoadingOverlay)),
      autoHeight: null,
      maximized: false
    };

    if (_this.props.showAggRow || _this.props.showBulkRow) {
      _this.state.defaultColumnDef.pinnedRowCellRenderer = RendererNames.BulkRenderer;
    } else {
      _this.state.defaultColumnDef.pinnedRowValueFormatter = Formatters.defaultFormatter;
    }

    _this.ref = React.createRef();

    if (_this.calculateAutoHeight) {
      window.addEventListener('resize', _this.setAutoHeightDebounced);
    }

    if (props.pagination) {
      if (props.internalPagination) {
        if (props.paginationTotalPages) {
          logger.warn('AgGrid: Provided property "paginationTotalPages" is used by custom pagination only');
        }

        if (props.paginationActivePage) {
          logger.warn('AgGrid: Provided property "paginationActivePage" is used by custom pagination only');
        }

        if (props.paginationHandlePageChange) {
          logger.warn('AgGrid: Provided property "paginationHandlePageChange" is used by custom pagination only');
        }

        if (props.paginationTotal) {
          logger.warn('AgGrid: Provided property "paginationTotal" is used by custom pagination only');
        }

        if (props.paginationOffset) {
          logger.warn('AgGrid: Provided property "paginationOffset" is used by custom pagination only');
        }

        if (props.paginationLimit) {
          logger.warn('AgGrid: Provided property "paginationLimit" is used by custom pagination only');
        }
      } else {
        if (props.paginationPageSize) {
          logger.warn('AgGrid: Provided property "paginationPageSize" is used by internal pagination only');
        }

        if (props.paginationAutoPageSize) {
          logger.warn('AgGrid: Provided property "paginationAutoPageSize" is used by internal pagination only');
        }

        if (props.suppressPaginationPanel) {
          logger.warn('AgGrid: Provided property "suppressPaginationPanel" is used by internal pagination only');
        }
      }

      if (props.excelExportParams && props.excelExportParams.type === 'custom' && !props.excelExportParams.getRowDataToExport) {
        logger.warn('AgGrid: If you want to use custom export, you have to provide getRowDataToExport');
      }
    }

    return _this;
  } // TODO: probably it doesnt work


  _createClass(AgGrid, [{
    key: "componentWillReact",
    value: function componentWillReact() {
      var _this2 = this;

      // Prevent leaving editing by clicks if value is invalid
      if (this.store.invalid) {
        Array.from(document.querySelectorAll('.ag-row')).forEach(function (element) {
          element.addEventListener('mousedown', _this2.preventCellClick);
          element.addEventListener('dblclick', _this2.preventCellClick);
        });
        var cell = document.querySelector('.ag-cell-focus');

        if (cell) {
          cell.addEventListener('mousedown', this.validateInputValue);
        }
      } // Removes prevention of leaving editing by clicks if value is valid
      else {
          Array.from(document.querySelectorAll('.ag-row')).forEach(function (element) {
            element.removeEventListener('mousedown', _this2.preventCellClick);
            element.removeEventListener('dblclick', _this2.preventCellClick);
            var cell = document.querySelector('.ag-cell-focus');

            if (cell) {
              cell.removeEventListener('mousedown', _this2.validateInputValue);
            }
          });
        }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.saveTreeDataExpansionId != null) {
        this.saveRowExpansion();
      }

      if (this.calculateAutoHeight) {
        window.removeEventListener('resize', this.setAutoHeightDebounced);
      }

      this.store.gridSettingsRemoveEventListeners();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.calculateAutoHeight) {
        if (this.props.debouncedInitialAutoHeight) {
          this.setAutoHeightDebounced();
        } else {
          this.setAutoHeight();
        }
      }
    }
  }, {
    key: "groupAggregation",
    value: function groupAggregation(values) {
      return values[0];
    }
    /**
     * Sets Api reference for search filter
     */

  }, {
    key: "onGridReady",
    value: function onGridReady(params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var extendedParams;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isGridInitialized) {
                  _context.next = 16;
                  break;
                }

                this.isGridInitialized = true;
                this.gridApi = params.api;
                this.gridColumnApi = params.columnApi;
                this.gridViewApi = new GridViewApi(this.store);
                this.store.setGridApis(this.gridApi, this.gridColumnApi, this.gridViewApi);
                this.gridApi.addAggFunc('group', this.groupAggregation);

                if (this.props.defaultFilterModel) {
                  params.api.setFilterModel(this.props.defaultFilterModel);
                }

                if (this.props.defaultSortModel) {
                  params.api.setSortModel(this.props.defaultSortModel);
                }

                if (this.props.sizeColumnsToFit) {
                  this.gridApi.sizeColumnsToFit();
                }

                if (this.props.onGridReady) {
                  extendedParams = Object.assign({}, params, {
                    gridStore: this.store,
                    gridViewApi: this.gridViewApi
                  });
                  this.props.onGridReady(extendedParams);
                } // Fixes low performance during startup of tooltips (LOG-4443)
                // TODO: This is unsupported and may break at any time
                // Related issue on ag-grid: https://github.com/ag-grid/ag-grid/issues/3225


                try {
                  params.api.context.beanWrappers.tooltipManager.beanInstance.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 0;
                } catch (e) {
                  console.error(e);
                }

                _context.next = 14;
                return this.store.gridSettingsLoad();

              case 14:
                if (this.props.onGridSettingsLoaded) {
                  this.props.onGridSettingsLoaded(params);
                }

                if (this.props.saveTreeDataExpansionId != null) {
                  this.restoreRowExpansion();
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * disables and/or conditions in filters when mode is set to viewport
     * https://www.ag-grid.com/javascript-grid-filter-provided-simple/
     */

  }, {
    key: "enforceSimpleFilterForOverviewMode",
    value: function enforceSimpleFilterForOverviewMode(colDefs) {
      if (this.props.rowModelType !== 'viewport') {
        return colDefs;
      }

      return colDefs.map(function (def) {
        if (!def.filterParams) {
          def.filterParams = {};
        }

        def.filterParams.suppressAndOrCondition = true;
        return def;
      });
    }
    /**
     * Sorts column headers alphabetically by headerName
     * @param columns
     */

  }, {
    key: "sortColumns",
    value: function sortColumns(columns) {
      return columns.sort(function (a, b) {
        if (a.headerName < b.headerName) {
          return -1;
        }

        if (a.headerName > b.headerName) {
          return 1;
        }

        return 0;
      });
    }
    /**
     * Function that returns array of context menu items
     */

  }, {
    key: "getContextMenuItems",
    value: function getContextMenuItems() {
      return ['copy', 'copyWithHeaders', {
        name: 'Export',
        subMenu: ['csvExport']
      }];
    }
  }, {
    key: "getBulkRow",
    value: function getBulkRow(columnDefs) {
      var _this3 = this;

      var bulkRow = {
        actions: 'Bulk edit: '
      };
      columnDefs.forEach(function (columnDef) {
        bulkRow[columnDef.field] = '';

        if (columnDef.children !== undefined) {
          var children = _this3.getBulkRow(columnDef.children);

          bulkRow = Object.assign(Object.assign({}, bulkRow), children);
        }
      });
      return bulkRow;
    }
  }, {
    key: "getAggRow",
    value: function getAggRow(columnDefs) {
      var _this4 = this;

      var aggRow = {
        actions: 'Aggregations: '
      };
      columnDefs.forEach(function (columnDef) {
        aggRow[columnDef.field] = '';

        if (columnDef.children !== undefined) {
          var children = _this4.getAggRow(columnDef.children);

          aggRow = Object.assign(Object.assign({}, aggRow), children);
        }
      });
      return aggRow;
    }
  }, {
    key: "getPinnedTopRowData",
    value: function getPinnedTopRowData() {
      var pinnedTopRows = this.props.pinnedTopRowData;

      if (this.props.showAggRow) {
        pinnedTopRows.unshift(this.getAggRow(this.props.columnDefs));
      }

      if (this.props.showBulkRow) {
        pinnedTopRows.unshift(this.getBulkRow(this.props.columnDefs));
      }

      return pinnedTopRows;
    }
    /**
     * Function that convert b64 encoded data to blob
     * @param b64Data b64 encoded data
     * @param contentType file type
     */

  }, {
    key: "b64toBlob",
    value: function b64toBlob(b64Data, contentType) {
      var sliceSize = 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);

        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, {
        type: contentType
      });
    }
    /**
     * Prevents leaving editation if value is invalid on focused cell (allow click events for pointer events inside cell)
     * @param e Event object
     */

  }, {
    key: "validateInputValue",
    value: function validateInputValue(e) {
      e.stopPropagation();
    }
    /**
     * Prevents leaving editation if value is invalid on all non-focused cells
     * @param e Event object
     */

  }, {
    key: "preventCellClick",
    value: function preventCellClick(e) {
      e.preventDefault();
    }
  }, {
    key: "handleRowSelection",
    value: function handleRowSelection(params) {
      if (this.props.onRowSelected) {
        this.props.onRowSelected(params);
      }

      this.store.setSelectedRows(params.api.getSelectedNodes());
    }
    /**
     * Returns the height of the grid which should be used.
     */

  }, {
    key: "height",
    get: function get() {
      if (this.state.maximized) {
        return window.innerHeight;
      }

      if (this.props.domLayout === 'viewport') {
        var viewport = this.viewportCalculation();

        if (viewport) {
          return viewport;
        }
      }

      if (this.props.domLayout === 'autoHeight') {
        return null;
      }

      if (this.props.height) {
        return this.props.height;
      }

      return this.state.autoHeight;
    }
    /**
     * Returns true if the height of the grid should be calculated automatically to the height of the screens remaining space. Returns false if AgGrids domLayout is set to 'autoHeight'.
     */

  }, {
    key: "calculateAutoHeight",
    get: function get() {
      return this.props.domLayout !== 'autoHeight' && !this.props.height || this.state.maximized;
    }
  }, {
    key: "isInModal",
    get: function get() {
      return this.ref.current ? this.ref.current.closest('.modal') : false;
    }
  }]);

  return AgGrid;
}(React.Component);

AgGrid = __decorate([inject(function (allStores) {
  return {
    grid: allStores[StoreName.Grid]
  };
}), observer, __metadata("design:paramtypes", [Object])], AgGrid);
export default AgGrid;
export var AgGridValidated = withValidation(AgGrid);